export const SCENE_PURPOSES = [
    'channel.merchandisingfeeds.pla',
    'design.studio.review',
    'gallery.tile',
] as const;

export type ScenePurpose = (typeof SCENE_PURPOSES)[number];
